import React, { memo, useEffect } from 'react';
import { withBlokWrapper } from '../../../../../BlokWrapper/BlokWrapper';
import { Theme } from '../../../../../../interfaces/enums/Theme.enum';

interface LiveChatWidgetProps {
  engagement_id: string;
}

const LiveChatWidget: React.FC<LiveChatWidgetProps> = ({ engagement_id }) => {
  const handleLiveChat = (e: any) => {
    e.preventDefault();
    const chatButton: HTMLElement = document.querySelector(
      '[data-lp-event="click"]'
    ) as HTMLElement;

    if (!chatButton) return null;

    chatButton?.click();
  };

  if (typeof window !== 'undefined') {
    if (window.lpTag?.newPage) {
      window.lpTag.newPage(window.location.href, {
        section: [],
        sdes: [],
        taglets: {
          rendererStub: {
            divIdsToKeep: {
              divId: true,
            },
          },
        },
      });
    }
  }

  return (
    <>
      <div className="fixed z-50 right-6 bottom-6 m-auto">
        <div className="flex justify-center items-center rounded-full w-[48px] h-[48px] bg-text/body-accent shadow-lg">
          <button
            className="w-6 h-6 scale-125 bg-contain cursor-pointer focus:!ring-0 focus:!outline-none bg-system/white"
            style={{
              WebkitMaskImage:
                'url(/svgs/move-specialist-live-chat-contact-icon-2.svg)',
              maskImage:
                'url(/svgs/move-specialist-live-chat-contact-icon-2.svg)',
            }}
            onClick={handleLiveChat}
          ></button>
        </div>
      </div>
      <div style={{ display: 'none' }}>
        <div id={engagement_id} className="chat-cont"></div>
      </div>
    </>
  );
};

export default withBlokWrapper(LiveChatWidget, Theme.ALT);
